import React, { PropTypes, Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Styles
import classes from './Profile.scss'

// Components
import { Heading } from 'components'

// Actions
import { userActions } from 'redux/actionCreators'

const mapStateToProps = () => ({})
const mapDispatchToProps = (dispatch) => ({
  attemptLogout: () =>
    dispatch(userActions.attemptLogout())
})

@connect(mapStateToProps, mapDispatchToProps)
class Profile extends Component {
  static propTypes = {
    attemptLogout: PropTypes.func.isRequired
  };
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentDidMount () {
    window.objectFitImages()
    if (this.props.location.pathname === '/profile') {
      this.context.router.replace('/profile/history')
    }
  }

  render () {
    const { location, attemptLogout } = this.props
    return (
      <section className={classes.profile}>
        <Helmet title='ข้อมูลส่วนตัว' />
        {location.pathname === '/profile/info' && (
          <div className='desktop'>
            <Heading>ข้อมูลส่วนตัว</Heading>
          </div>
        )}
        <div className={`${classes.leftCol} desktop`}>{this.props.children}</div>
        <div className={classes.rightCol}>
          <div className={classes.link}>
            <img className={classes.profile} src='/images/icon-profile-orange.png' alt='orange' width='25' height='25' />
            <Link to='/profile/info' activeClassName={classes.active}>แก้ไขข้อมูลส่วนตัว</Link>
          </div>
          <div className={classes.link}>
            <img className={classes.history} src='/images/icon-history-orange.png' alt='history' width='25' height='20' />
            <Link to='/profile/history' activeClassName={classes.active}>รายการสั่งซื้อ</Link>
          </div>
          <div className={classes.link}>
            <img className={classes.logout} src='/images/icon-logout-orange.png' alt='logout' width='25' height='11' />
            <a onClick={attemptLogout}>ออกจากระบบ</a>
          </div>
        </div>
        <div className={`${classes.leftCol} mobile`}>{this.props.children}</div>
      </section>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/containers/User/Profile/Profile.js